import React from 'react';
import { useMediaQuery } from 'react-responsive';
import DomainRegistrationContent from './DomainRegistrationContent';

const Desktop = ({ children }) => {
  const isDesktop = useMediaQuery({ minWidth: 768 });
  return isDesktop ? children : null;
};

const DesktopResponsive = ({
  open,
  domainName,
  handleKeyDown,
  handleDomainOpen,
  handleOnChange,
}) => (
  <Desktop>
    <DomainRegistrationContent
      open={open}
      domainName={domainName}
      handleKeyDown={handleKeyDown}
      handleDomainOpen={handleDomainOpen}
      handleOnChange={handleOnChange}
    />
  </Desktop>
);

export default DesktopResponsive;
